// PlatformIcon — renders a small platform-specific glyph for an event or
// meetup group: meetup.com logo, Facebook F, pedestrian Footprints for
// Bitcoin Walks, and a generic calendar fallback for anything else.
//
// Used by:
//   - components/map/Sidebar.js   (events list in /map)
//   - pages/Events.js             (sidebar "Bitcoin Groups" card)
//
// The `item` prop can be either an event or a group — both expose
// platform / event_url / url fields that getEventPlatform() will resolve.

import { Facebook, Footprints, CalendarDays } from 'lucide-react';
import { MEETUP_LOGO, getEventPlatform } from './MapHelpers';

const PlatformIcon = ({ item, className = 'w-5 h-5', title }) => {
  const platform = getEventPlatform(item);
  const label = title || `Source: ${platform || 'external'}`;

  if (platform === 'meetup') {
    return <img src={MEETUP_LOGO} alt="Meetup" title={label} className={className} />;
  }
  if (platform === 'facebook') {
    return <Facebook className={`${className} text-[#1877F2]`} strokeWidth={2} aria-label={label} />;
  }
  if (platform === 'bitcoin_walk') {
    return <Footprints className={`${className} text-emerald-600 dark:text-emerald-400`} strokeWidth={2} aria-label={label} />;
  }
  return <CalendarDays className={`${className} text-blue-600 dark:text-blue-400`} strokeWidth={2} aria-label={label} />;
};

export default PlatformIcon;
